import { render, staticRenderFns } from "./MicroHome.vue?vue&type=template&id=014ed7cc&scoped=true&"
import script from "./MicroHome.vue?vue&type=script&lang=ts&"
export * from "./MicroHome.vue?vue&type=script&lang=ts&"
import style0 from "./MicroHome.vue?vue&type=style&index=0&id=014ed7cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ed7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
